import './Updates.css'
import './SuperResponsiveTableStyle.css'
import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { data } from '../../data/UpdatesData';


const Updates = () => {
    return (
        <div className='updatesContainer'>
            <h1 className='headingText'>App updates</h1>
            <p className='updatesIntro'>Recent releases are summarised from the <a href='https://play.google.com/store/apps/details?id=com.sami246.foodi'>Google Play</a> and <a href='https://apps.apple.com/gb/app/foodii-restaurant-companion/id6447701868'>App Store</a> listings. Dates show the later store release where platforms differ; older entries use our original changelog.</p>
            <Table className='Table'>
                <Thead className='TableHead'>
                    <Tr>
                        <Th>Version</Th>
                        <Th>Description</Th>
                        <Th>Date</Th>
                        <Th>Android</Th>
                        <Th>iOS</Th>
                    </Tr>
                </Thead>

                <Tbody className='TableBody'>
                    {data.map((row) => (
                        <Tr key={row.version}>
                            <Td className='cell'>{row.version}</Td>
                            <Td className='cell description'>
                                {row.description?.map((point, index) => (
                                    <ul key={index}>
                                        <li className='main'>
                                            {point.main}
                                            {point.sub &&
                                                <ul>
                                                    {point.sub.map((sub, subIndex) => (
                                                        <li key={subIndex} className='sub'>{sub}</li>
                                                    ))}
                                                </ul>
                                            }
                                        </li>
                                    </ul>

                                ))}
                            </Td>
                            <Td className='cell'>{row.date}</Td>
                            <Td className='cell'>{row.android == null ? 'Not verified' : row.android ? "Yes ✅" : "No ⛔"}</Td>
                            <Td className='cell'>{row.ios ? "Yes ✅" : "No ⛔"}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>

        </div>
    )
}

export default Updates
